import { useTranslate } from '../../../components/TranslationText';

/**
 * Semen order statuses.
 * Matches Flutter's SemenRequestStatus enum.
 */
export const OrderStatus = {
    UnderReview: 'UnderReview',
    InProgress: 'InProgress',
    PendingPayment: 'PendingPayment',
    Paid: 'Paid',
    Rejected: 'Rejected',
    Return: 'Return',
    Completed: 'Completed',
};

/**
 * Semen order statuses with display colors.
 */
export const ORDER_STATUS = {
    [OrderStatus.UnderReview]: { color: '#FF9800', bgColor: '#FFF3E0' },
    [OrderStatus.InProgress]: { color: '#2196F3', bgColor: '#E3F2FD' },
    [OrderStatus.PendingPayment]: { color: '#FFC107', bgColor: '#FFFDE7' },
    [OrderStatus.Paid]: { color: '#4CAF50', bgColor: '#E8F5E9' },
    [OrderStatus.Rejected]: { color: '#F44336', bgColor: '#FFEBEE' },
    [OrderStatus.Return]: { color: '#F44336', bgColor: '#FFEBEE' },
    [OrderStatus.Completed]: { color: '#4CAF50', bgColor: '#E8F5E9' },
};

/**
 * Get status display info (color + bgColor).
 * Falls back to gray if status is unknown.
 */
export const getStatusStyle = (status) =>
    ORDER_STATUS[status] || { color: '#757575', bgColor: '#F5F5F5' };

/**
 * Check if order is in pending payment state.
 */
export const isPendingPayment = (status) => status === OrderStatus.PendingPayment;

/**
 * Check if payment documents should be shown.
 * Show when pending payment OR when payment files already exist.
 */
export const shouldShowPaymentDocs = (status, details) =>
    isPendingPayment(status) ||
    !!details?.paymentCertificateFile?.fileUrl ||
    !!details?.signedContractFile?.fileUrl;
